$(function () {
    if($('.rethinkers-slider-stories').length) {
        $('.rethinkers-slider-stories .container').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            prevArrow: $('.rethinkers__slider-stories--prev'),
            nextArrow: $('.rethinkers__slider-stories--next'),
            responsive: [
                {
                    breakpoint: 650,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 1030,
                    settings: {
                        slidesToShow: 2,

                    }
                },
            ]
        });
    }

    if ($('.slider-filter').length) {
        $('.slider-filter__item').on('click', function (e) {
            e.preventDefault();
            let filter = $(e.target).data('filter');
            $('.rethinkers-slider-stories .container').slick('slickUnfilter');
            if (filter !== 'all') {
                $('.rethinkers-slider-stories .container').slick('slickFilter', function() {
                    return $(this).data('type') === filter;
                });
            }
        });
    }
});
